// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + "07dc7b23f9c935eb1a7a" + ".js";
};